'use client';

import { useLanguage } from '@/context/LanguageContext';
import privatumoPoliLt from '@/data/static-pages/privatumo-politika.lt.json';
import privatumoPoliEn from '@/data/static-pages/privatumo-politika.en.json';
import privatumoPoliPl from '@/data/static-pages/privatumo-politika.pl.json';
import privatumoPoliRu from '@/data/static-pages/privatumo-politika.ru.json';
import privatumoPoliUa from '@/data/static-pages/privatumo-politika.ua.json';

import slapukuPoliLt from '@/data/static-pages/slapuku-politika.lt.json';
import slapukuPoliEn from '@/data/static-pages/slapuku-politika.en.json';
import slapukuPoliPl from '@/data/static-pages/slapuku-politika.pl.json';
import slapukuPoliRu from '@/data/static-pages/slapuku-politika.ru.json';
import slapukuPoliUa from '@/data/static-pages/slapuku-politika.ua.json';

import naudojimosiLt from '@/data/static-pages/naudojimosi-taisykles.lt.json';
import naudojimosiEn from '@/data/static-pages/naudojimosi-taisykles.en.json';
import naudojimosiPl from '@/data/static-pages/naudojimosi-taisykles.pl.json';
import naudojimosiRu from '@/data/static-pages/naudojimosi-taisykles.ru.json';
import naudojimosiUa from '@/data/static-pages/naudojimosi-taisykles.ua.json';

import nuolaiduLt from '@/data/static-pages/nuolaidu-programos-taisykles.lt.json';
import nuolaiduEn from '@/data/static-pages/nuolaidu-programos-taisykles.en.json';
import nuolaiduPl from '@/data/static-pages/nuolaidu-programos-taisykles.pl.json';
import nuolaiduRu from '@/data/static-pages/nuolaidu-programos-taisykles.ru.json';
import nuolaiduUa from '@/data/static-pages/nuolaidu-programos-taisykles.ua.json';

import prieinamumasLt from '@/data/static-pages/prieinamumas.lt.json';
import prieinamumasEn from '@/data/static-pages/prieinamumas.en.json';
import prieinamumasPl from '@/data/static-pages/prieinamumas.pl.json';
import prieinamumasRu from '@/data/static-pages/prieinamumas.ru.json';
import prieinamumasUa from '@/data/static-pages/prieinamumas.ua.json';

const PAGES = {
  'privatumo-politika': {
    lt: privatumoPoliLt,
    en: privatumoPoliEn,
    pl: privatumoPoliPl,
    ru: privatumoPoliRu,
    ua: privatumoPoliUa,
  },
  'slapuku-politika': {
    lt: slapukuPoliLt,
    en: slapukuPoliEn,
    pl: slapukuPoliPl,
    ru: slapukuPoliRu,
    ua: slapukuPoliUa,
  },
  'naudojimosi-taisykles': {
    lt: naudojimosiLt,
    en: naudojimosiEn,
    pl: naudojimosiPl,
    ru: naudojimosiRu,
    ua: naudojimosiUa,
  },
  'nuolaidu-programos-taisykles': {
    lt: nuolaiduLt,
    en: nuolaiduEn,
    pl: nuolaiduPl,
    ru: nuolaiduRu,
    ua: nuolaiduUa,
  },
  prieinamumas: {
    lt: prieinamumasLt,
    en: prieinamumasEn,
    pl: prieinamumasPl,
    ru: prieinamumasRu,
    ua: prieinamumasUa,
  },
};

export function useStaticPage(slug) {
  const { locale } = useLanguage();
  const pageSet = PAGES[slug];
  if (!pageSet) {
    throw new Error(`Unknown static page: ${slug}`);
  }
  return pageSet[locale] || pageSet.lt;
}
